import { render, staticRenderFns } from "./PreenrollmentCopyParagraphs.vue?vue&type=template&id=1d5a7b6f"
import script from "./PreenrollmentCopyParagraphs.vue?vue&type=script&lang=ts"
export * from "./PreenrollmentCopyParagraphs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports